import { Trans } from "react-i18next";
import { Icon } from "../icon/Icon";
import { IconType } from "../icon/IconType";
import { LinkButton, type LinkButtonProps } from "../Link";

export const UndoButton = (props: Omit<LinkButtonProps, "iconBefore" | "children">) => (
  <LinkButton iconBefore={<Icon type={IconType.Reset} />} {...props}>
    <Trans i18nKey={"common.undo"} />
  </LinkButton>
);
